(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-password"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  /*
   * Set your launch date here.
   *
   * Example:
   * October 31, 2026 at 8:00 PM
   *
   * Format:
   * YYYY-MM-DDTHH:MM:SS
   */

  const launchDate = new Date("2026-10-31T20:00:00").getTime();

  const days = document.getElementById("libbie-days");
  const hours = document.getElementById("libbie-hours");
  const minutes = document.getElementById("libbie-minutes");
  const seconds = document.getElementById("libbie-seconds");

  if (!days || !hours || !minutes || !seconds) {
    return;
  }

  function updateCountdown() {

    const now = new Date().getTime();

    const distance = launchDate - now;

    if (distance <= 0) {

      days.textContent = "00";
      hours.textContent = "00";
      minutes.textContent = "00";
      seconds.textContent = "00";

      return;
    }

    const d = Math.floor(
      distance / (1000 * 60 * 60 * 24)
    );

    const h = Math.floor(
      (distance % (1000 * 60 * 60 * 24))
      / (1000 * 60 * 60)
    );

    const m = Math.floor(
      (distance % (1000 * 60 * 60))
      / (1000 * 60)
    );

    const s = Math.floor(
      (distance % (1000 * 60))
      / 1000
    );

    days.textContent = String(d).padStart(2, "0");
    hours.textContent = String(h).padStart(2, "0");
    minutes.textContent = String(m).padStart(2, "0");
    seconds.textContent = String(s).padStart(2, "0");
  }

  updateCountdown();

  setInterval(updateCountdown, 1000);

});


  } catch(e) { console.error(e); }
})();
})();
